import React, { forwardRef } from 'react';

import type { ButtonBaseProps } from '@mui/material';
import { ButtonBase } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    '&.Mui-disabled': {
      color: theme.palette.action.disabled,
    },
    color: theme.appColors.iconsType,
  },
  /* Styles applied if disabled=true */
  disabled: {},
}));

interface PlainIconProps extends ButtonBaseProps {
  Icon: React.FC;
}

const PlainIconButtonWithRef = forwardRef(function PlainIconButton(
  props: PlainIconProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  const { Icon, className, disabled, ...buttonBaseProps } = props;

  const { classes } = useStyles();

  return (
    <ButtonBase
      ref={ref}
      className={clsx(classes.button, { [classes.disabled]: disabled }, className)}
      disabled={disabled}
      {...buttonBaseProps}
    >
      <Icon />
    </ButtonBase>
  );
});

export const PlainIconButton = React.memo(PlainIconButtonWithRef);
